import React from 'react';
import { Platform } from 'react-native';

function PlayIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      className="w-6 h-6 text-white translate-x-0.5"
    >
      <path
        fillRule="evenodd"
        d="M4.5 5.653c0-1.427 1.529-2.33 2.779-1.643l11.54 6.347c1.295.712 1.295 2.573 0 3.286L7.28 19.99c-1.25.687-2.779-.217-2.779-1.643V5.653Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

function ChevronRight() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
      className="w-5 h-5 transition-transform group-hover:translate-x-1"
    >
      <path
        fillRule="evenodd"
        d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export function ReanimatePromo() {
  if (Platform.OS !== 'web') {
    return null;
  }

  return (
    <a
      href="https://reanimate.dev"
      target="_blank"
      rel="noopener noreferrer"
      className="block mt-10 no-underline hover:no-underline group"
    >
      <div className="relative overflow-hidden rounded-2xl bg-[#0f0f13] p-6 border border-white/10 hover:border-white/20 transition-all">
        {/* Gradient glow accent */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-gradient-to-br from-[#1c89ff]/15 via-[#00bcf6]/10 to-transparent blur-3xl -translate-y-1/2 translate-x-1/4" />

        <div className="relative flex items-center gap-5">
          {/* Play icon with gradient - matching reanimate.dev colors */}
          <div className="shrink-0 w-14 h-14 rounded-xl bg-gradient-to-br from-[#1c89ff] to-[#00bcf6] flex items-center justify-center overflow-hidden shadow-lg shadow-[#1c89ff]/5">
            <PlayIcon />
          </div>

          {/* Content */}
          <div className="flex-1 min-w-0">
            <h3 className="text-base font-semibold text-white mb-0.5">
              Unlock the beauty of React Native animations
            </h3>
            <p className="text-sm text-gray-500">
              Learn Reanimated, Gesture Handler & Skia with{' '}
              <span className="text-gray-300">Reanimate.dev</span>
            </p>
          </div>

          {/* Arrow */}
          <div className="shrink-0 text-gray-500 group-hover:text-white transition-colors">
            <ChevronRight />
          </div>
        </div>
      </div>
    </a>
  );
}
